import { render, staticRenderFns } from "./lkuUser.vue?vue&type=template&id=0980aa82"
import script from "./lkuUser.vue?vue&type=script&lang=js"
export * from "./lkuUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports